import React from 'react';

const Team = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8252 9.78027C7.88607 9.78027 8.90347 10.2017 9.65361 10.9519C10.4038 11.702 10.8252 12.7194 10.8252 13.7803V18.7803C10.8252 19.0455 10.7198 19.2999 10.5323 19.4874C10.3448 19.6749 10.0904 19.7803 9.8252 19.7803H3.8252C3.55998 19.7803 3.30563 19.6749 3.11809 19.4874C2.93056 19.2999 2.8252 19.0455 2.8252 18.7803V13.7803C2.8252 12.7194 3.24662 11.702 3.99677 10.9519C4.74692 10.2017 5.76433 9.78027 6.8252 9.78027Z"
        fill="#C7CED5"
      />
      <path
        d="M6.8252 8.78027C8.20591 8.78027 9.3252 7.66098 9.3252 6.28027C9.3252 4.89956 8.20591 3.78027 6.8252 3.78027C5.44449 3.78027 4.3252 4.89956 4.3252 6.28027C4.3252 7.66098 5.44449 8.78027 6.8252 8.78027Z"
        fill="#C7CED5"
      />
      <path
        d="M21.8252 19.7803H15.8252C15.56 19.7803 15.3056 19.6749 15.1181 19.4874C14.9305 19.2999 14.8252 19.0455 14.8252 18.7803V13.7803C14.8252 12.7194 15.2466 11.702 15.9968 10.9519C16.7469 10.2017 17.7643 9.78027 18.8252 9.78027C19.8861 9.78027 20.9035 10.2017 21.6536 10.9519C22.4038 11.702 22.8252 12.7194 22.8252 13.7803V18.7803C22.8252 19.0455 22.7198 19.2999 22.5323 19.4874C22.3448 19.6749 22.0904 19.7803 21.8252 19.7803Z"
        fill="#C7CED5"
      />
      <path
        d="M18.8252 8.78027C20.2059 8.78027 21.3252 7.66098 21.3252 6.28027C21.3252 4.89956 20.2059 3.78027 18.8252 3.78027C17.4445 3.78027 16.3252 4.89956 16.3252 6.28027C16.3252 7.66098 17.4445 8.78027 18.8252 8.78027Z"
        fill="#C7CED5"
      />
      <path
        d="M11.9453 12.7803H13.6953C14.7562 12.7803 15.7736 13.2017 16.5237 13.9519C17.2739 14.702 17.6953 15.7194 17.6953 16.7803V21.7803C17.6953 22.0455 17.59 22.2999 17.4024 22.4874C17.2149 22.6749 16.9605 22.7803 16.6953 22.7803H8.94531C8.68009 22.7803 8.42574 22.6749 8.2382 22.4874C8.05066 22.2999 7.94531 22.0455 7.94531 21.7803V16.7803C7.94531 15.7194 8.36673 14.702 9.11688 13.9519C9.86702 13.2017 10.8845 12.7803 11.9453 12.7803Z"
        fill="#6B758F"
      />
      <path
        d="M12.8252 11.7803C14.2059 11.7803 15.3252 10.661 15.3252 9.28027C15.3252 7.89956 14.2059 6.78027 12.8252 6.78027C11.4445 6.78027 10.3252 7.89956 10.3252 9.28027C10.3252 10.661 11.4445 11.7803 12.8252 11.7803Z"
        fill="#6B758F"
      />
    </svg>
  );
};

export default Team;
